module.exports = __webpack_public_path__ + "media/images/rocket-7f5229135c368d7dd52949e7218516ff.svg";